<template>
  <div class="resource-visit">
    <div class="resource-visit-top">
        <div class="title">资源访问</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        <div class="time-box">
          <div class="time-type" @click="changeTimeType('day')" :class="timeType == 'day' ? 'is-select' : ''">日</div>
          <div class="line"></div>
          <div class="time-type" @click="changeTimeType('week')" :class="timeType == 'week' ? 'is-select' : ''">周</div>
          <div class="line"></div>
          <div class="time-type" @click="changeTimeType('month')" :class="timeType == 'month' ? 'is-select' : ''">月</div>
        </div>
    </div>
    <div class="resource-visit-echarts">
      <div style="width:100%;height: 100%" id="visitEchartsId"></div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'resource-visit',
  data() {
    return {
      timeType:'day'
    }
  },
  methods: {
    initEcharts(){
      let chartDom = document.getElementById('visitEchartsId');
      let myChart = echarts.init(chartDom);
      let option;
      let data = [];
      if(this.timeType == 'day'){
        data = ['08.11', '08.12', '08.13', '08.14', '08.15', '08.16', '08.17']
      }else if(this.timeType == 'week'){
        data = ['20周', '21周', '22周', '23周', '24周', '25周', '26周']
      }else{
        data = ['6月', '7月', '8月', '9月', '10月', '11月', '12月']
      }
      option = {
        xAxis: {
          type: 'category',
          data: data,
          name:"时间",
          axisLabel: {  
            textStyle: {  
                color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
            },
            interval:0
          },  
          nameTextStyle: {  // 这里设置Y轴名称文字的样式  
              color: '#6EA0D3',  // 这里将颜色设置为红色  
              fontSize: 12   // 还可以设置字体大小等其他样式  
          },
        },
        yAxis: {
          type: 'value',
          name:"活跃指数（%）",
          splitLine: {
            show: false
          },
          axisLabel: {  
            textStyle: {  
                color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
            }  
          },  
          nameTextStyle: {  // 这里设置Y轴名称文字的样式  
              color: '#6EA0D3',
              fontSize: 12   // 还可以设置字体大小等其他样式  
          },
        },
        grid: {
          left: "20px",
          right: "60px",
          bottom: "0",
          containLabel: true,
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            lineStyle: {  
                color: '#24AB6D'
            },
            itemStyle: {  
                color: '#24AB6D'
            },
            areaStyle: {  
                color: {  
                    type: 'linear',  
                    x: 0,  
                    y: 0,  
                    x2: 0,  
                    y2: 1,  
                    colorStops: [  
                        {offset: 0, color: '#061135'},   // 0% 处的颜色  
                        {offset: 1, color: '#245D7C'}   // 100% 处的颜色  
                    ],  
                    global: false   // 缺省为 false  
                }  
            }  
          }
        ]
      };

      option && myChart.setOption(option);
    },
    changeTimeType(type){
      this.timeType = type
      this.initEcharts();
    }
  },
  mounted() {
    this.initEcharts();
  },
}
</script>
<style lang="scss" scoped>
.resource-visit{
    width: 100%;
    height: 250px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .resource-visit-top{
        position: relative;
        text-align: center;
        // margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
        .time-box{
          position: absolute;
          right: 10px;
          display: inline-flex;
          top: 50%;
          transform: translateY(-50%);
          // align-content: center;
          justify-content: space-between;
          color: #359AFF;
          .line{
            width: 1px;
            height: 100%;
            background: linear-gradient(0deg, #061136 0%, #2E87E3 50%, #061136 100%);
            margin: 0 8px;
          }
          .time-type{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
          }
          .is-select{
            color:#38FFF3;
            border-bottom: 2px solid #38FFF3;
          }
        }
    }
    .resource-visit-echarts{
      width: 100%;
      height: 210px;
      padding-bottom: 10px;
      position: relative;
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>